import { useEffect, useState } from 'react';

/**
 * @param {string} initialMappingName
 * @returns {import("../../data/types/types").CreateMappingNameHookReturn}
 */
export const useCreateMappingName = (initialMappingName) => {
  const [mappingName, setMappingName] = useState('');

  useEffect(() => {
    setMappingName(initialMappingName);
  }, [initialMappingName]);

  return {
    mappingName,
    setMappingName,
  };
};
